import { useTranslation } from "react-i18next";
import { PageDataStats } from "@/components/PageDataStats";
import { useMsGetEventStatsQuery } from "@/services/(my-space)/api.events";

export const MySpaceEventStats = () => {
  const { t } = useTranslation("my-space");
  const { data: stats, isLoading } = useMsGetEventStatsQuery();

  const statsData = [
    {
      name: t("ui.total_events"),
      value: stats?.data.totalEvents ?? 0,
      icon: "/icons/interface-icons/stats/events/icon-3d-calendar.png",
    },
    {
      name: t("ui.completed_events"),
      value: stats?.data.completedEvents ?? 0,
      icon: "/icons/interface-icons/stats/shared/icon-3d-green-check.png",
    },
    {
      name: t("ui.cancelled_events"),
      value: stats?.data.cancelledEvents ?? 0,
      icon: "/icons/interface-icons/stats/shared/icon-3d-red-x.png",
    },
    {
      name: t("ui.archived_events"),
      value: stats?.data.archivedEvents ?? 0,
      icon: "/icons/interface-icons/stats/events/icon-3d-drawer.png",
    },
  ];

  return <PageDataStats data={statsData} loading={isLoading} />;
};
